import { apiRequest } from "./common";

const createExam = async (data) => {
    const response = await apiRequest('post', '/exam', data);
    return response.data;
};

const updateExam = async (id, data) => {
    const response = await apiRequest('put', `/exam/${id}`, data);
    return response.data;
};

const deleteExam = async (id) => {
    const response = await apiRequest('delete', `/exam/${id}`);
    return response.data;
};

const getExamList = async (studentId, pageNo, pageSize, filters) => {
    const response = await apiRequest('get', `/exam/by-student/${studentId}?page=${pageNo}&limit=${pageSize}&filters=${filters}`);
    return response.data;
};

const getExamCount = async (studentId) => {
    const response = await apiRequest('get', `/exam/count-by-student/${studentId}`);
    return response.data;
};

const getUpComingExamList = async (studentId) => {
    const response = await apiRequest('get', `/exam/upcoming/${studentId}`);
    return response.data;
};


export {
    createExam,
    updateExam,
    deleteExam,
    getExamList,
    getExamCount,
    getUpComingExamList
};
